module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABK0lEQVR42mNgGAWjYBSMglEwCkbB4AbTF0dvn7E4+v2MRTE/ZyyKWkZNs5nI0TRjUfSRWUtj/4Mw0GELqeYaoGEXQQZOWxDhV9hrwUm8g2IOwRw0fVH0dKo5aNqiqDQkn34BBv/q6Qsiwuqn2PMQ8MhWJH27pi6KSp6+MLpu+qKoxdMXxZwFOvI82VEGDP4zMMPhvl4c/R2ITwAtWQ6kp01bGN0JwkC1s4CWbQM5Hl0PMp62MKqY7FCaPC/MCGjBX3wWkIJBju3s9OOlONdQy0GgKJs0K1SRMgctjK6mloPAoQQsDihy0IQ5YTrUdBAIU17YLYqaBMR7QBiYeE9CcgsQL46+CcT3QBjo8wfgAhEJo6Wff6AyavqiyOjR6mMUjIJRMApGwSigIwAA96qHO1Kha34AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/dlc.png
// module id = 609
// module chunks = 0